<template>
  <v-card
    class="mx-auto modern-course-card"
    min-height="240"
    @click="navigateToCourseDetailsPage(course._id)"
  >
    <div class="pa-3">
      <v-img
        height="140"
        :src="course.images ? getImage(course.images) : null"
        lazy-src="@/app/core-module/assets/images/logo_placeholder.png"
        cover
        class="rounded-lg course-image"
      />
    </div>

    <v-card-title class="pt-0 pb-3">
      <p
        class="text-start body-2 textLight--text ma-0 text-ellipse-2"
        style="opacity: 0.8; height: 35px"
      >
        {{ getLocalisedValue(course.title) }}
      </p>
    </v-card-title>

    <v-card-text class="pt-0 pb-3">
      <div class="d-flex align-end">
        <v-icon color="primary"> mdi-book-open-variant</v-icon>

        <span class="primary--text ms-3">
          {{ course.totalContents }}

          {{ $t("course.assignedCourses.lessons") }}
        </span>
      </div>
    </v-card-text>

    <v-card-text class="pt-0 pb-3">
      <div class="d-flex justify-space-between">
        <span class="body-2 textLight--text text-truncate" style="opacity: 0.8">
          {{ $t("course.courseDetails.appliedOn") }}

          {{
            course.createdAt
              ? moment(parseInt(course.createdAt)).format("DD MMM YYYY")
              : "-"
          }}
        </span>
      </div>
      <div class="d-flex justify-space-between">
        <div>
          <v-avatar style="justify-content: left" width="30" height="30">
            <img
              :src="
                course.createdBy && course.createdBy.avatar
                  ? getImage(course.createdBy.avatar)
                  : require('@/app/user-module/assets/images/user-placeholder.png')
              "
            />
          </v-avatar>
          <span>
            {{
              course.createdBy && course.createdBy.firstName
                ? course.createdBy.firstName
                : "-"
            }}</span
          >
          <span v-if="course.createdBy && course.createdBy.lastName">
            {{ course.createdBy.lastName }}</span
          >
        </div>

        <v-icon size="20" class="hover-arrow">mdi-arrow-right</v-icon>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    course: {
      type: Object,
    },
  },
  data() {
    return {
      data: this.course,
    };
  },
  methods: {
    navigateToCourseDetailsPage(trainingId) {
      this.$router.push({
        name: "CourseDetails",
        params: { trainingId },
      });
    },
  },
};
</script>
<style scoped>
.modern-course-card {
  border-radius: 16px !important;
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 4px 20px 0 rgba(31, 38, 135, 0.05) !important;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  cursor: pointer;
}
.modern-course-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 30px 0 rgba(31, 38, 135, 0.12) !important;
  border-color: rgba(89, 40, 229, 0.2);
}
.course-image {
  transition: transform 0.5s ease;
}
.modern-course-card:hover .course-image {
  transform: scale(1.03);
}
.hover-arrow {
  transition: transform 0.3s ease;
}
.modern-course-card:hover .hover-arrow {
  transform: translateX(4px);
  color: #5928e5;
}
</style>
